import React from "react";
import { HttpResponseError, isHttpResponseError, useFetch } from "./useFetch";
import Loading, { ErrorPage } from "../components/Loading";
import NotFound from "../components/NotFound";
import { trackError } from "../tracking/error";
import { useT } from "../helpers/useT";

type Props = {
  apiCall: ReturnType<typeof useFetch>;
  render: (data: any, error?: HttpResponseError) => JSX.Element;
  renderNotFound?: boolean;
};

export function ApiResponseAware({ apiCall, render, renderNotFound }: Props) {
  if (apiCall.error) {
    if (isHttpResponseError(apiCall.error, 404)) {
      if (renderNotFound) {
        return render(null, apiCall.error as HttpResponseError);
      } else {
        return <NotFound />;
      }
    } else if (isHttpResponseError(apiCall.error, 429)) {
      return <RateLimited />;
    } else {
      trackError("Error loading data", apiCall.error);
      return <ErrorPage />;
    }
  }

  if (apiCall.isLoading || !apiCall.data) {
    return <Loading />;
  }

  return render(apiCall.data);
}

function RateLimited() {
  const t = useT();
  return <div>{t("load.rate-limited")}</div>;
}
